export enum FeatureName {
  MAINTENANCE = 'maintenance',
  LAUNCH_POPUP = 'launch-popup',
  RANKINGS = 'rankings_variant',
  EMOTE_CATEGORIES = 'emote-categories',
  RENTALS = 'rentals',
  CAMPAIGN_HOMEPAGE_BANNER = 'campaign-homepage-banner',
  CAMPAIGN_COLLECTIBLES_BANNER = 'campaign-collectibles-banner',
  CAMPAIGN_BROWSER = 'campaign-browser'
}
